export default __webpack_public_path__ + "static/media/icon1.a9d730e4.png";